import { withPrefix } from 'gatsby-link'

const carouselSlides = [
  {
    src: withPrefix('/img/past_work/thomas_theatres_1680.jpg'),
    title: 'Thomas Theatres',
    caption: ''
  },
  {
    src: withPrefix('/img/past_work/staybridge_suites_1680.jpg'),
    title: 'Staybridge Suites',
    caption: ''
  },
  {
    src: withPrefix('/img/past_work/uphp_1680.jpg'),
    title: 'Upper Peninsula Health Plan',
    caption: ''
  },
  {
    src: withPrefix('/img/past_work/chandelier_1680.jpg'),
    title: 'Residential',
    caption: ''
  }
];

export default carouselSlides


// WEBPACK FOOTER //
// ./src/data/carouselSlides.js